import { API } from 'src/utils/AmplifyApiUtils';
import { FileResponse } from 'src/store/files/types';
import { SignaturePageComponent } from 'src/store/signaturePage/types';

interface SignatureEventParams {
  fileId: string;
}

interface SendSignatureEventParams extends SignatureEventParams {
  body: {
    components: Array<SignaturePageComponent>;
  };
}

export default class SignatureClient {
  /**
   * Send signature file
   * @param params object with file id and request payload
   * @returns Promise
   */
  static SendSignatureFile(
    params: SendSignatureEventParams,
  ): Promise<FileResponse> {
    return API.post('AppAPI', `/files/${params.fileId}/signature`, {
      body: params.body,
    });
  }

  /**
   * Cancel signature submit, this is used when saving the file signature
   * file fails
   */
  static CancelSignature(params: SignatureEventParams): Promise<FileResponse> {
    return API.post('AppAPI', `/files/${params.fileId}/signature/cancel`, {});
  }
}
